// extracted by mini-css-extract-plugin
export default {"container":"SwitchHospital_container__qlV-3","dropdownsContainer":"SwitchHospital_dropdownsContainer__86tIK","buttonContainer":"SwitchHospital_buttonContainer__0G7mq"};